import React, { useEffect, useState } from "react"
import { CustomHeader } from "../../../components/headers/CustomHeader"
import {
  Button,
  CardBody,
  Input,
  Typography,
  Spinner,
  Tooltip,
} from "@material-tailwind/react"
import { DEFAULTPRIMARYCOLOR } from "../../../util"
import { GETALLNEWPOLICIES, GETPOLICYREQUESTID } from "../../../GraphQl/queries"
import { useQuery, useLazyQuery } from "@apollo/client"
import moment from "moment"

import { FiDownloadCloud } from "react-icons/fi"
import Papa from "papaparse"
import { getColorCode } from "../../../colorCodes"
import { useSelector } from "react-redux"
import { RootState } from "../../../store/store"
import PerPageAndPagination from "../../../components/paginations/perpageAndPagination"

import { CANCELPOLICY } from "../../../GraphQl/mutations"
import { useMutation } from "@apollo/client"
import ConfirmationDialog from "../../../config/confirmationbox"

import { toast } from "react-toastify"
import dayjs from "dayjs";
import ChangeOwnerDialog from "./changeOwnerDialog"


type TurnquestInteg = {
  batch_number: string;
  turnquest_policy_number: string;
  endorsement_number: string;
  debit_number: string;
};


interface Policyy {
  id: string
  policy_number: string
  policy_stage: string
  created_at: string
  certificate_number: string
  request: {
    payment_channel: string
    vehicle_reg_no: string
    client_details: {
      first_name: string
      last_name: string
      phone_number: string
      __typename: "customers"
    }
    vehicle_details_metadata: string
    end_date: string
    start_date: string
    user_type: string
    sub_agent: null | any // Replace 'any' with a more specific type if known
    company_staff: {
      id: string
      phone_number: string
      name: string
      phone_number_one: string
      branch: {
        id: string
        name: string
      }
      division: {
        id: string
        name: string
      }
      __typename: "company_staff"
    }
    amount: string
    cover_type: string
    benefit_added_details: {
      extra_pa: number
      extra_tppdl: number
      loss_of_use: number
      excess_buy_back: boolean
      umbrella_tppdl_limit: number
    }
    amended_rated_details: {
      fleet_discount: number
      other_discount: number
      own_damage_rate: number
      no_claim_discount: number
    }
    vehicle_details: {
      color: string
      body_type: string
      vehicle_model: string
      vehicle_value: string
      chassis_number: string
      make_of_vehicle: string
      number_of_seats: number
      accessories_value: string
      registration_number: string
      year_of_manufacture: string
    }
    created_at: string
    __typename: "request"
  }
  debit_number: string
  reciept_number: string
  status: string
  turnquest_integs: TurnquestInteg[]
  __typename: "policy"
}

const NewPolicyView = () => {
  const [searchText, setSearchText] = useState("")

  const defaultStart = moment().subtract(1, "months").format("YYYY-MM-DDTHH:mm");
  const defaultEnd = moment().format("YYYY-MM-DDTHH:mm");
  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);
  const [tempStartDate, setTempStartDate] = useState(defaultStart);
  const [tempEndDate, setTempEndDate] = useState(defaultEnd);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState<Policyy[] | undefined>(undefined)
  const [searchFilterStart, setSearchFilterStart] = useState("");
  const [searchFilterEnd, setSearchFilterEnd] = useState("");

  const {
    companyId,
    user: stateUser,
    token,
  } = useSelector((state: RootState) => state.auth)

  useEffect(() => {
    if (companyId) {
      localStorage.setItem("company_id", companyId)
    }
  }, [companyId])


  


  const handleSearch = () => {
    search()
  }

  const handleTempStartDateChange = (event: any) => {
    const value = event.target.value
    if (value) {
      const dateOnly = value.split("T")[0]; // Extract just the date part
      const formattedValue = `${dateOnly}T00:00`; // Set time to 12:00 AM
      setTempStartDate(formattedValue);
    }
  }

  const handleTempEndDateChange = (event: any) => {
    const value = event.target.value
    if (value) {
      const formattedValue = value
      setTempEndDate(formattedValue)
    }
  }

  const handleDateChange = () => {
    const start = dayjs(tempStartDate);
    const end = dayjs(tempEndDate);
    const diffInMonths = end.diff(start, 'month', true);

    setIsFilterLoading(true);
    if (searchData !== undefined) {
      setSearchFilterStart(tempStartDate)
      setSearchFilterEnd(tempEndDate)
      setIsFilterLoading(false);
    } else {
      if (diffInMonths > 3) {
        toast.error("Date range cannot exceed 3 months.");
        setTempStartDate(defaultStart);
        setTempEndDate(defaultEnd);
        setIsFilterLoading(false);
        return;
      }

      setTimeout(() => {
        fetchData({
          variables: {
            id: companyId,
            start_date: tempStartDate,
            end_date: tempEndDate,
            status: "NR"
          }
        });
        setIsFilterLoading(false);
      }, 1000);
    }
  };

  const reset = () => {
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setTempStartDate(defaultStart);
    setTempEndDate(defaultEnd);
    setSearchFilterStart("");
    setSearchFilterEnd("");
    if (searchData === undefined) {
      fetchData({
        variables: {
          id: companyId,
          start_date: defaultStart,
          end_date: defaultEnd,
          status: "NR"
        }
      });
    }
  }

  function filterPoliciesByDateRange(
    policies: Policyy[],
    fromDate: any,
    toDate: any
  ) {
    // If no dates are provided, return all policies
    if (!fromDate || !toDate) {
      return policies
    }

    const from = new Date(fromDate)
    from.setHours(0, 0, 0, 0)

    const to = new Date(toDate)
    to.setHours(23, 59, 59, 999)

    return policies?.filter((policy: Policyy) => {
      const policyStartDate = new Date(policy?.request?.start_date)
      policyStartDate.setHours(0, 0, 0, 0)

      const policyEndDate = new Date(policy?.request?.end_date)
      policyEndDate.setHours(23, 59, 59, 999)

      return policyStartDate >= from && policyEndDate <= to
    })
  }

  const userData = stateUser
  const [colors, setColors] = useState<string[]>()

  useEffect(() => {
    if (userData) {
      // const data: UserType = JSON.parse(userData)

      const colors = getColorCode(stateUser?.colors)

      setColors(colors)
    }
  }, [userData, stateUser?.colors])

  const [fetchData, { data, loading, refetch }] = useLazyQuery<{
    policy: Policyy[]
  }>(GETALLNEWPOLICIES, {
    variables: {
      stage: "new",
      id: companyId,
    },
  })
  // console.log("New Policies Data: ", data?.policy)

  useEffect(() => {
    fetchData({
      variables: {
        stage: "new",
        id: companyId,
        start_date: defaultStart,
        end_date: defaultEnd,
        status: "NR"
      }
    });
  }, [companyId]);


  const search = async () => {
    if (searchText) {
      try {
        setIsFilterLoading(true)
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/search-new-policies?company_id=${companyId}&search_term=${searchText}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )

        const req = await response.json()

        if (response.ok) {
          setSearchData(req.data.policy)
          toast.success(req?.message)
        } else {
          toast.error(req?.message)
        }
        setIsFilterLoading(false)
      } catch (error) {
        toast.error("Could not perform search")
        setIsFilterLoading(false)
      }
    }
  }


  const filterData = (filter: Policyy) => {
    const date1 = moment(filter?.request?.start_date).format("LL")
    const date2 = moment(filter?.request?.end_date).format("LL")
    const isTextMatch =
      filter?.policy_number
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.policy_stage
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.reciept_number
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.request?.amount
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.request?.amended_rated_details
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.certificate_number
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.request?.company_staff?.name
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.request?.company_staff?.branch?.name
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.request?.company_staff?.division?.name
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.request?.company_staff?.phone_number
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.request?.cover_type
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.status
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.request?.vehicle_reg_no
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      date1?.toString()?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
      date2?.toString()?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
      filter?.request?.sub_agent?.last_name
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.request?.sub_agent?.first_name
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      `${filter?.request?.sub_agent?.first_name || ""} ${filter?.request?.sub_agent?.last_name || ""
        }`
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.request?.client_details?.first_name
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.request?.client_details?.last_name
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.request?.client_details?.phone_number
        ?.toString()
        ?.replace(/^233/, "0") // Replace '233' at the start with '0'
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      `${filter?.request?.client_details?.first_name || ""} ${filter?.request?.client_details?.last_name || ""
        }`
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.request?.sub_agent?.phone_number
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.request?.user_type
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase()) ||
      filter?.request?.payment_channel
        ?.toLowerCase()
        ?.includes(searchText?.toLowerCase())

    return isTextMatch
  }

  const searchDateStart = searchFilterStart ? searchFilterStart : tempStartDate
  const searchDateEnd = searchFilterEnd ? searchFilterEnd : tempEndDate

  function filterDate(item: Policyy): boolean {
    const date = new Date(item?.created_at);

    const start = new Date(searchDateStart);
    const end = new Date(searchDateEnd);

    return date >= start && date <= end;
  }

  //------------------
  const handleDownload = () => {
    // Check if there is data to download
    if (paginatedData?.length === 0) {
      alert("No data to download.")
      return
    }
    // Define custom headers based on the selected filter

    if (searchText || startDate || endDate) {
      const type = totalItems?.map((item: Policyy) => ({
        "Policy Number": item?.policy_number,
        "TurnQuest Policy Number":
          item?.turnquest_integs?.length > 0
            ? item.turnquest_integs[0]?.turnquest_policy_number ?? "N/A"
            : "N/A",
         "Debit Number":
          item?.turnquest_integs?.length > 0
            ? item.turnquest_integs[0]?.debit_number ?? "N/A"
            : "N/A",
        "Certificate Number": item?.certificate_number,
        "Vehicle Reg. No.": item?.request.vehicle_reg_no,
        "Payment Channel": item?.request.payment_channel,
        "Client Details": item?.request.client_details
          ? `${item?.request.client_details?.first_name} ${item?.request.client_details?.last_name}`
          : "",
        "Vehicle Details": item?.request.vehicle_details_metadata.split(",")[0],
        "Cover Details": item?.request.cover_type,
        "Financial Details (GHS)": `${parseFloat(
          (item?.request?.amount as any) ?? 0
        ).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        "Staff/Intermediary": item?.request.company_staff
          ? item?.request.company_staff?.name
          : `${item?.request.sub_agent?.first_name} ${item?.request.sub_agent?.last_name}`,
        "Branch/Division": `${item?.request.company_staff?.branch?.name}/ ${item?.request.company_staff?.division?.name}`,
        "Date Created": moment(item?.created_at).format("YYYY-MM-DD"),
        "Policy Start Date": moment(item?.request.start_date).format("YYYY-MM-DD"),
        "Policy End Date": moment(item?.request.end_date).format("YYYY-MM-DD"),
        Status: item?.status
       

      }))
      const firstItem = type![0]
      const originalHeaders = Object.keys(firstItem!)
      const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
      // Transform data to match headers (Simplified)
      const transformedData = type?.map((item) => {
        const transformedItem: Record<string, string> = {};
        originalHeaders.forEach((originalKey, idx) => {
          const upperKey = upperHeaders[idx];
          transformedItem[upperKey] = (item as Record<string, string>)[originalKey];
        });
        return transformedItem;
      });
      // Convert data to CSV format
      const csvData = Papa.unparse({
        fields: upperHeaders,
        data: transformedData!,
      })
      // Create a Blob and download link
      const blob = new Blob([csvData], { type: "text/csv" })
      const url = window.URL.createObjectURL(blob)
      // Create a download link
      const a = document.createElement("a")
      a.href = url
      a.download = `${"New Policies"}.csv`
      document.body.appendChild(a)
      // Trigger a click on the link to start the download
      a.click()
      // Cleanup
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    } else {
      const type = data?.policy?.map((item: Policyy) => ({
        "Policy Number": item?.policy_number,
        "TurnQuest Policy Number":
          item?.turnquest_integs?.length > 0
            ? item.turnquest_integs[0]?.turnquest_policy_number ?? "N/A"
            : "N/A",
         "Debit Number":
          item?.turnquest_integs?.length > 0
            ? item.turnquest_integs[0]?.debit_number ?? "N/A"
            : "N/A",
        "Certificate Number": item?.certificate_number,
        "Vehicle Reg. No.": item?.request.vehicle_reg_no,
        "Payment Channel": item?.request.payment_channel,
        "Client Details": item?.request.client_details
          ? `${item?.request.client_details?.first_name} ${item?.request.client_details?.last_name}`
          : "",
        "Vehicle Details": item?.request.vehicle_details_metadata.split(",")[0],
        "Cover Details": item?.request.cover_type,
        "Financial Details GHS": `${parseFloat(
          (item?.request?.amount as any) ?? 0
        ).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        "Staff/Intermediary": item?.request.company_staff
          ? item?.request.company_staff?.name
          : `${item?.request.sub_agent?.first_name} ${item?.request.sub_agent?.last_name}`,
        "Branch/Division": `${item?.request.company_staff?.branch?.name}/ ${item?.request.company_staff?.division?.name}`,
        "Date Created": moment(item?.created_at).format("YYYY-MM-DD"),
        "Policy Start Date": moment(item?.request.start_date).format("YYYY-MM-DD"),
        "Policy End Date": moment(item?.request.end_date).format("YYYY-MM-DD"),

        Status: item?.status,
      }))
      const firstItem = type![0]
      const originalHeaders = Object.keys(firstItem!)
      const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
      // Transform data to match headers (Simplified)
      const transformedData = type?.map((item) => {
        const transformedItem: Record<string, string> = {};
        originalHeaders.forEach((originalKey, idx) => {
          const upperKey = upperHeaders[idx];
          transformedItem[upperKey] = (item as Record<string, string>)[originalKey];
        });
        return transformedItem;
      });
      // Convert data to CSV format
      const csvData = Papa.unparse({
        fields: upperHeaders,
        data: transformedData!,
      })
      // Create a Blob and download link
      const blob = new Blob([csvData], { type: "text/csv" })
      const url = window.URL.createObjectURL(blob)
      // Create a download link
      const a = document.createElement("a")
      a.href = url
      a.download = `${"New Policies"}.csv`
      document.body.appendChild(a)
      // Trigger a click on the link to start the download
      a.click()
      // Cleanup
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    }


  }


  const [currentPage, setCurrentPage] = useState(0)
  const [itemsPerPage, setItemsPerPage] = useState(10)

  useEffect(() => {
    if (searchText || startDate || endDate || itemsPerPage) {
      setCurrentPage(0)
    }
  }, [searchText, startDate, endDate, itemsPerPage])

  const displayData = searchData !== undefined ? searchData : data?.policy
  const filteredPolicies = (searchFilterStart || searchFilterEnd || searchDateStart || searchDateEnd) ? displayData?.filter(filterDate) : displayData
  // ?.filter(filterData)

  const totalItems = filteredPolicies

  // const paginatedData = totalItems?.slice(startIndex, endIndex)
  const endOffset = currentPage + itemsPerPage
  const paginatedData = totalItems?.slice(currentPage, endOffset)

  // Delete Policy
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [policyId, setPolicyId] = useState<string | null>(null);

  const [cancelPolicy, { loading: load, error: err }] = useMutation(CANCELPOLICY, {
    variables: { id: policyId },
    onCompleted: () => {
      setCancelDialogOpen(false);
      refetch();

    },
    onError: (err) => {
      if (err instanceof Error) {
        console.error("Failed to cancel policy:", err.message);
      } else {
        console.error("Unknown error during cancellation", err);
      }
    },
  });

  const handleConfirm = () => {
    if (!policyId) {
      return;
    }
    cancelPolicy();
  }

  const [changeOwnerDialogOpen, setChangeOwnerDialogOpen] = useState(false);
  const [newOwnerId, setNewOwnerId] = useState<string>("");
  const [fetchRequestData, { data: requestData, loading: requestLoading, refetch: requestRefetch }] = useLazyQuery(GETPOLICYREQUESTID, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (policyId && changeOwnerDialogOpen) {
      fetchRequestData({
        variables: {
          id: policyId
        }
      });
    }
  }, [policyId, changeOwnerDialogOpen, fetchRequestData]);

  const requestID = requestData?.policy[0]?.request?.id;

 


  const refresh = () => {
    setIsFilterLoading(true)
    fetchData({
      variables: {
        id: companyId,
        start_date: tempStartDate,
        end_date: tempEndDate,
        status:"NR"
      }
    });
    setIsFilterLoading(false);
    search()
  }

  const changeOwner = async () => {
    const newOwnerID = localStorage.getItem("newOwnerId")
    if (!requestID && !newOwnerID) {
      toast.error("Failed to change policy owner")
      return;
    } else {
      try {
        if (newOwnerID === "") {
          // toast.error("Please select a new owner")
          return
        } else {
          setIsFilterLoading(true)
          const response = await fetch(
            `${process.env.REACT_APP_BASE_URL}/change-policy-owner?request_id=${requestID}&new_owner_id=${newOwnerID}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          )

          const req = await response.json()

          if (response.ok) {
            toast.success(req?.message)
          } else {
            toast.error(req?.message)
          }
          setIsFilterLoading(false)
        }
        localStorage.setItem("newOwnerId", "")
        refresh()
      } catch (error) {
        toast.error("Failed to change policy ownership")
        setIsFilterLoading(false)
        localStorage.setItem("newOwnerId", "")
      }
    }
  }


  const handleChangeOwner = () => {
    changeOwner();
  }

  return (
    <>
      <ConfirmationDialog
        show={cancelDialogOpen}
        setShow={setCancelDialogOpen}
        onConfirm={() => {
          handleConfirm();
        }}
      />
      <ChangeOwnerDialog
        isOpen={changeOwnerDialogOpen}
        onClose={() => {
          setChangeOwnerDialogOpen(false)
          handleChangeOwner()
        }}
        onChangeOwner={id => setNewOwnerId(id)}
      />
      <CustomHeader title="New Policies" />

      <div className="mt-10 w-full">
        <CardBody className="shadow-sm sticky px-0 py-0  rounded-3xl w-full">
          <div className="bg-black pt-5 rounded-t-2xl">
            <Typography
              variant="h6"
              style={{
                color:
                  colors?.length! > 1
                    ? `${colors![0]?.toLowerCase()}`
                    : `${DEFAULTPRIMARYCOLOR}`,
              }}
              className="px-4 pb-4 font-bold leading-none opacity-70 capitalize"
            >
              Total policies{" "}
              {data?.policy && (
                <span className="text-white text-sm bg-admin-red p-1 rounded-md">
                  {totalItems?.length}
                </span>
              )}
            </Typography>
          </div>
          <div className="flex flex-col gap-y-2 bg-white p-3">
            <div className="flex shrink-0 flex-col  justify-end gap-2 sm:flex-row ml-7">
              <Tooltip content="Export as CSV">
                <Button
                  onClick={handleDownload}
                  variant="filled"
                  className="capitalize text-sm font-normal flex flex-wrap gap-2"
                  size="sm"
                >
                  <FiDownloadCloud size={20} />
                  <span>Download csv</span>
                </Button>
              </Tooltip>
            </div>
            <div className="p-3 flex gap-x-5 items-center flex-col 2xl:flex-row gap-y-3 mb-5">
              <div className="w-full flex flex-row gap-x-2">
                <Input
                  crossOrigin="anonymous"
                  label="Search"
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value)
                    if (e.target.value === "") {
                      setSearchText("")
                      setSearchData(undefined)
                      setSearchFilterStart("")
                      setSearchFilterEnd("")
                    }
                  }}
                  icon={<i className="fas fa-search text-base"></i>}
                />
                <Button
                  onClick={handleSearch}
                  variant="filled"
                  className="capitalize text-sm font-normal flex flex-wrap justify-center items-center"
                  size="sm"
                >
                  <span>Search</span>
                </Button>
              </div>

              <div className="flex flex-col xl:flex-row gap-3 justify-between mb-0">
                <div className="flex items-center space-x-2">
                  <label className="font-semibold text-gray-700">From</label>
                  <Input
                    type="datetime-local"
                    value={tempStartDate} // Remove 'Z' for input value
                    onChange={handleTempStartDateChange}
                    size="md"
                    className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                  />
                </div>
                <div className="flex items-center space-x-2">
                  <label className="font-semibold text-gray-700">To</label>
                  <Input
                    type="datetime-local"
                    value={tempEndDate} // Remove 'Z' for input value
                    onChange={handleTempEndDateChange}
                    size="md"
                    className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                  />
                </div>
                <div className="flex items-center space-x-2">
                  <Tooltip content="Apply date filters">
                    <Button
                      onClick={handleDateChange}
                      variant="filled"
                      className="capitalize text-sm font-normal flex flex-wrap gap-2"
                      size="sm"
                    >
                      <span>Filter</span>
                    </Button>
                  </Tooltip>
                </div>
                <div className="flex items-center space-x-2">
                  <Tooltip content="Clear All Date filters">
                    <Button
                      onClick={reset}
                      variant="filled"
                      className="capitalize text-sm font-normal flex flex-wrap gap-2"
                      size="sm"
                    >
                      <span>Clear</span>
                    </Button>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
          <CardBody className="px-0 py-0">
            <div
              className="overflow-x-auto overflow-y-auto"
              style={{ maxHeight: "65vh" }}
            >
              <table className=" bg-white w-full min-w-max table-auto">
                <thead className="bg-white sticky z-50 top-0">
                  <tr>
                    {[
                      "policy no.",
                      "certificate no.",
                      "vehicle reg. no.",
                      "Channel",
                      "client details",
                      "Vehicle details",
                      "cover details",
                      "Financial details",
                      "TurnQuest details",
                      "Staff/Intermediary",
                      "date created",
                      "policy start date",
                      "policy end date",
                      "status",
                      "action"
                    ].map((head) => (
                      <th
                        key={head}
                        className=" border-y border-blue-gray-100 text-black bg-gray-50/50 p-4"
                      >
                        <Typography
                          color="black"
                          className="font-bold text-sm text-black leading-none opacity-70 capitalize"
                        >
                          {head}
                        </Typography>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {paginatedData?.map((item, index: number) => {
                    const isLast = index === paginatedData?.length - 1
                    const classes = isLast
                      ? "p-2  text-center"
                      : "p-2 border-b-2 border-blue-gray-50 text-center"

                    return (
                      <tr
                        key={index}
                        className="hover:bg-gray-100 transition-all hover:cursor-pointer"
                      >
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.policy_number}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.certificate_number}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.request.vehicle_reg_no}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {item?.request.payment_channel}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <div className="flex flex-col gap-2 text-left">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Name:{" "}
                              <span className="font-normal">
                                {item?.request?.client_details
                                  ? `${item?.request?.client_details?.first_name} ${item?.request?.client_details?.last_name}`
                                  : ""}
                              </span>
                            </Typography>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Phone No.:{" "}
                              <span className="font-normal">
                                {item?.request?.client_details?.phone_number}
                              </span>
                            </Typography>
                          </div>
                        </td>
                        <td className={classes}>
                          <div className="flex flex-col gap-2 text-left">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Vehicle Make:{" "}
                              <span className="font-normal">
                                {
                                  item?.request?.vehicle_details_metadata
                                    ?.split(",")[1]
                                    .split(" ")[2]
                                }
                              </span>
                            </Typography>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Vehicle Model:{" "}
                              <span className="font-normal">
                                {
                                  item?.request?.vehicle_details_metadata
                                    ?.split(",")[0]
                                    .split(" ")[1]
                                }
                              </span>
                            </Typography>

                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Yr. of Manufacture:{" "}
                              <span className="font-normal">
                                {
                                  item?.request?.vehicle_details
                                    ?.year_of_manufacture
                                }
                              </span>
                            </Typography>

                            {/* <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-bold text-xs capitalize "
                        >
                          Chasis:{" "}
                          <span className="font-normal">
                            {item?.request?.vehicle_details?.chassis_number
                              ? item?.request?.vehicle_details?.chassis_number
                              : "N/A"}
                          </span>
                        </Typography> */}
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Color:{" "}
                              <span className="font-normal">
                                {item?.request?.vehicle_details?.color}
                              </span>
                            </Typography>
                          </div>
                        </td>
                        <td className={classes}>
                          <div className="flex flex-col gap-2 text-left">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Cover Type:{" "}
                              <span className="font-normal">
                                {item?.request?.cover_type}
                              </span>
                            </Typography>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize"
                            >
                              Vehicle & Accessories:{" "}
                              <span className="font-normal">
                                GHS{" "}
                                {parseFloat(
                                  (
                                    ((item?.request?.vehicle_details
                                      ?.vehicle_value as any) ?? 0) +
                                    ((item?.request?.vehicle_details
                                      ?.accessories_value as any) ?? 0)
                                  ).toString()
                                ).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </span>
                            </Typography>

                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize"
                            >
                              TPPD:{" "}
                              <span className="font-normal">
                                GHS{" "}
                                {parseFloat(
                                  (
                                    ((item?.request?.benefit_added_details
                                      ?.extra_tppdl as any) ?? 0) + 6000
                                  ).toString()
                                ).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </span>
                            </Typography>

                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize"
                            >
                              P.A Benefits:{" "}
                              <span className="font-normal">
                                GHS{" "}
                                {parseFloat(
                                  (
                                    ((item?.request?.benefit_added_details
                                      ?.extra_pa as any) ?? 0) + 7000
                                  ).toString()
                                ).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </span>
                            </Typography>
                          </div>
                        </td>
                        <td className={classes}>
                          <div className="flex flex-col gap-2 text-left">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Premium Paid:{" "}
                              <span className="font-normal">
                                GHS{" "}
                                {parseFloat(
                                  (item?.request?.amount as any) ?? 0
                                ).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </span>
                            </Typography>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Debit No.:{" "}
                              <span className="font-normal">
                                {item?.debit_number}
                              </span>
                            </Typography>

                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Receipt No.:{" "}
                              <span className="font-normal">
                                {item?.reciept_number}
                              </span>
                            </Typography>
                          </div>
                        </td>
                        <td className={classes}>
                          <div className="flex flex-col gap-2 text-left">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Policy Number:{" "}
                              <span className="font-normal">
                                {item?.turnquest_integs?.length > 0
                                  ? item.turnquest_integs[0]?.turnquest_policy_number || "N/A"
                                  : "N/A"}
                              </span>

                            </Typography>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Endorsement Number:{" "}
                              {item?.turnquest_integs?.[0]?.endorsement_number ?? "N/A"}
                            </Typography>

                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Debit Number:{" "}
                              {item?.turnquest_integs?.[0]?.debit_number ?? "N/A"}
                            </Typography>

                          </div>
                        </td>

                        <td className={classes}>
                          <div className="flex flex-col gap-2 text-left">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Full name:{" "}
                              <span className="font-normal">
                                {item?.request?.company_staff
                                  ? `${item?.request?.company_staff?.name}`
                                  : `${item?.request?.sub_agent?.first_name} ${item?.request?.sub_agent?.last_name}`}
                              </span>
                            </Typography>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Phone number:{" "}
                              <span className="font-normal">
                                {item?.request?.company_staff
                                  ? item?.request?.company_staff?.phone_number
                                  : item?.request?.sub_agent?.phone_number}
                              </span>
                            </Typography>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              Branch/Division:{" "}
                              <span className="font-normal">
                                {item?.request?.company_staff
                                  ? `${item?.request?.company_staff?.branch?.name} / ${item?.request?.company_staff?.division?.name}`
                                  : "N/A"}
                              </span>
                            </Typography>

                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-bold text-xs capitalize "
                            >
                              User type:{" "}
                              <span className="font-normal">
                                {item?.request?.company_staff
                                  ? "Company Staff"
                                  : "Sub Agent"}
                              </span>
                            </Typography>
                          </div>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs "
                          >
                            {moment(item?.created_at).format("LL")}
                          </Typography>
                        </td>

                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs "
                          >
                            {moment(item?.request?.start_date).format("LL")}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal text-xs capitalize"
                          >
                            {moment(item?.request?.end_date).format("LL")}
                          </Typography>
                        </td>
                        <td className={classes}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className={`font-normal text-xs capitalize
                              ${item?.status === "active" ? "text-green-800" : " text-red-800"
                              }`}
                          >
                            {(item?.status)}
                          </Typography>
                        </td>
                        <td
                          className={classes}
                          onClick={(e) => {
                            e.stopPropagation()
                          }}
                        >
                          <div className="flex flex-row gap-2 items-center justify-center">
                            {item?.status === "active" && <Button
                              onClick={() => {
                                setPolicyId(item?.id)
                                setCancelDialogOpen(true)
                              }}
                              variant="filled"
                              color="red"
                              className="font-normal text-xs w-20 py-1 capitalize pt-3 pb-3"
                            >
                              Cancel
                            </Button>}
                            <Button
                              onClick={() => {
                                setPolicyId(item?.id)
                                setChangeOwnerDialogOpen(true)
                              }}
                              variant="filled"
                              // color="blue"
                              className="bg-black font-normal text-xs w-fit py-1 capitalize pt-3 pb-3"
                            >
                              change owner
                            </Button>
                          </div>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </CardBody>

          {(loading || isFilterLoading) && (
            <div className="mt-10 flex items-center justify-center">
              <Spinner className="w-10 h-10" />
            </div>
          )}

          {paginatedData?.length! === 0 && !loading && !isFilterLoading && (
            <div className="my-10 flex items-center justify-center">
              <Typography color="white" variant="h6">
                No data found
              </Typography>
            </div>
          )}
        </CardBody>

        {paginatedData && paginatedData?.length! !== 0 && !loading && !isFilterLoading && (
          // <GeneralPagination
          //   totalItems={totalItems?.length!}
          //   itemsPerPage={itemsPerPage}
          //   currentPage={currentPage}
          //   onPageChange={handlePageChange}
          // />
          <PerPageAndPagination
            customColor="white"
            total={totalItems?.length!}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            perPage={itemsPerPage}
            setPerPage={setItemsPerPage}
          />
        )}
      </div>
    </>
  )
}

export default NewPolicyView
